import { motion } from "framer-motion";
import { CheckCircle2 } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";

const COPY = {
  en: {
    eyebrow: "Coverage",
    title: "Serving Across Saudi Arabia",
    body: "Based in Jeddah, we provide services across key cities and high-demand routes.",
    areas: ["Jeddah", "Makkah", "Madinah", "Airport Transfers across major locations"],
  },
  ar: {
    eyebrow: "نطاق الخدمة",
    title: "نخدم في أنحاء المملكة العربية السعودية",
    body: "ننطلق من جدة ونوفر خدماتنا في المدن الرئيسية والمسارات الأكثر طلباً.",
    areas: ["جدة", "مكة", "المدينة", "خدمات المطارات عبر المواقع الرئيسية"],
  },
};

export default function CoverageSection() {
  const { lang } = useLanguage();
  const copy = COPY[lang] || COPY.en;

  return (
    <section className="relative py-20 md:py-24 bg-[#050505] coverage-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6 }}
          className="rounded-[30px] border border-white/10 bg-[linear-gradient(135deg,#141414,#090909)] p-8 md:p-10 coverage-panel"
        >
          <p className="text-xs uppercase tracking-[0.25em] text-[#C7A239] font-medium mb-4">{copy.eyebrow}</p>
          <h2 className="font-['Playfair_Display'] text-3xl md:text-4xl font-semibold text-white mb-4 coverage-title">{copy.title}</h2>
          <p className="text-gray-400 mb-8 max-w-3xl coverage-body">{copy.body}</p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {copy.areas.map((area) => (
              <div key={area} className="rounded-2xl border border-white/8 bg-white/[0.03] p-5 flex items-center gap-3 text-white coverage-chip">
                <CheckCircle2 className="w-5 h-5 text-[#C7A239] shrink-0" />
                <span>{area}</span>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
}
